import { render, staticRenderFns } from "./unreadMessagesCount.vue?vue&type=template&id=210c3213"
import script from "./unreadMessagesCount.vue?vue&type=script&lang=js"
export * from "./unreadMessagesCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports